export default {
      id: "i-cycle-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/sprite.svg#i-cycle",
      toString: function () {
        return this.url;
      }
    }